import type { ReactNode } from 'react';
import { cloneElement, type FC, isValidElement } from 'react';

import {
    FormControl,
    FormField,
    FormItem,
    FormMessage,
} from '@/components/molecules/Form';

export interface FormFieldWrapperProps {
    name: string;
    label: string;
    children: ReactNode;
}

export const FormFieldWrapper: FC<FormFieldWrapperProps> = ({
    name,
    label,
    children,
}) => (
    <FormField
        name={name}
        render={({ field, fieldState }) => (
            <FormItem className="py-3">
                <FormControl>
                    {isValidElement(children)
                        ? cloneElement(children, {
                              ...field,
                              // @ts-ignore
                              isError: Boolean(fieldState.error),
                              name,
                              label,
                          })
                        : children}
                </FormControl>

                <FormMessage />
            </FormItem>
        )}
    />
);

export default FormFieldWrapper;
